import { pb } from "lib/pocketbase";

async function getPortfolios() {
  try {
    let response = await pb.collection("portfolio").getFullList({
      sort: "-sort_order",
      expand: "service_type",
    });

    return response;
  } catch (error) {
    console.log(error);
    return null; // Return empty on error
  }
}

export { getPortfolios };
